(() => {
      const originalButtonId = window.adev.atcb.originalButtonId;
      const stickyButtonId = window.adev.atcb.stickyButtonId;
      const stickyWrapperId = window.adev.atcb.stickyWrapperId;
      const productId = window.adev.atcb.productId;

      /**
       * Start the sticky add-to-cart functionality.
       */
      function initialiseStickyAddToCart() {
        const originalButton = document.getElementById(originalButtonId);
        const stickyButton = document.getElementById(stickyButtonId);
        const stickyWrapper = document.getElementById(stickyWrapperId);

        if (!originalButton || !stickyButton || !stickyWrapper) {
          return;
        }

        if (stickyWrapper.dataset.stickyInitialised === 'true') {
          return;
        }

        stickyWrapper.dataset.stickyInitialised = 'true';

        const stickySealContainer = stickyWrapper.querySelector(
          '[data-sticky-seal-container]'
        );

        const stickySealWidget = stickyWrapper.querySelector(
          '[data-sticky-seal-widget]'
        );

        let sealRefreshRequested = false;
        let sealSelectionIsSynchronising = false;
        let sealUpdateFrame = null;

        /*
         * Moving the sticky bar to body prevents parent elements with
         * overflow or transform properties from clipping the fixed bar.
         */
        if (stickyWrapper.parentElement !== document.body) {
          document.body.appendChild(stickyWrapper);
        }

        stickyWrapper.hidden = false;

        /**
         * Find the product form connected to the original button.
         */
        function getOriginalProductForm() {
          return originalButton.closest('form[action*="/cart/add"]')
            || originalButton.closest('form');
        }

        document.addEventListener(
  'change',
  (event) => {
    const field = event.target;

    if (!(field instanceof HTMLSelectElement)) {
      return;
    }

    const variantPicker =
      field.closest('variant-picker');

    if (!variantPicker) {
      return;
    }

    /*
     * Only respond to the main product's variant picker.
     */
    if (
      variantPicker.dataset.productId &&
      String(variantPicker.dataset.productId) !== String(productId)
    ) {
      return;
    }

    if (!field.name?.startsWith('options[')) {
      return;
    }

    refreshStickySealForVariant();
    syncStickyButton();
  }
);

        /**
         * Determine whether an element belongs to the current product.
         */
        function belongsToCurrentProduct(element) {
          if (!element) {
            return false;
          }

          const widgetProductId = element.dataset.productId;

          if (widgetProductId) {
            return String(widgetProductId) === String(productId);
          }

          const productForm = getOriginalProductForm();

          return Boolean(
            productForm
            && (
              productForm.contains(element)
              || element.closest('form') === productForm
            )
          );
        }

        /**
         * Return Seal widgets from the original product area,
         * excluding the widget inside the sticky bar.
         */
        function getOriginalSealWidgets() {
          const allWidgets = Array.from(
            document.querySelectorAll('.sealsubs-target-element')
          );

          return allWidgets.filter((widget) => {
            if (widget === stickySealWidget) {
              return false;
            }

            if (stickyWrapper.contains(widget)) {
              return false;
            }

            return belongsToCurrentProduct(widget);
          });
        }

        /**
         * Detect whether Seal rendered meaningful widget content.
         */
        function sealWidgetHasContent(widget) {
          if (!widget) {
            return false;
          }

          return Boolean(
            widget.querySelector(
              [
                'input',
                'select',
                'button',
                'label',
                '.sealsubs-container',
                '[class*="sealsubs"]'
              ].join(',')
            )
          );
        }

        /**
         * Check whether the original product page has an active Seal widget.
         */
        function originalSealWidgetExists() {
          return getOriginalSealWidgets().some(sealWidgetHasContent);
        }

        /**
         * Check whether the sticky Seal widget finished rendering.
         */
        function stickySealWidgetExists() {
          return sealWidgetHasContent(stickySealWidget);
        }

        /**
         * Show the sticky widget only when both the original and
         * sticky Seal widgets have actually rendered.
         */
        function updateStickySealVisibility() {
          if (!stickySealContainer || !stickySealWidget) {
            return;
          }

          const shouldShowSealWidget =
            originalSealWidgetExists()
            && stickySealWidgetExists();

          stickySealContainer.hidden = !shouldShowSealWidget;
        }

        /**
         * Queue a visibility update so repeated DOM mutations do not
         * cause excessive synchronous work.
         */
        function queueStickySealVisibilityUpdate() {
          if (sealUpdateFrame) {
            window.cancelAnimationFrame(sealUpdateFrame);
          }

          sealUpdateFrame = window.requestAnimationFrame(() => {
            sealUpdateFrame = null;
            updateStickySealVisibility();
          });
        }

        /**
         * Ask Seal to scan and render newly added target elements.
         */
        function refreshSealWidgets() {
          if (
            !window.SealSubs
            || typeof window.SealSubs.refresh !== 'function'
          ) {
            return false;
          }

          window.SealSubs.refresh();
          sealRefreshRequested = true;

          return true;
        }

        function refreshStickySealForVariant() {
  if (!stickySealWidget) {
    return;
  }

  if (
    !window.SealSubs ||
    typeof window.SealSubs.refresh !== 'function'
  ) {
    return;
  }

  /*
   * Remove only Seal's rendered contents.
   * Keep the actual target element and all its data attributes.
   *
   * SealSubs.refresh() will then render this target again
   * for the currently selected product variant.
   */
  stickySealWidget.innerHTML = '';

  window.SealSubs.refresh();

  /*
   * Keep it hidden until Seal has rendered it again.
   */
  queueStickySealVisibilityUpdate();
}

        /**
         * Keep trying briefly because Seal can load after the theme code.
         */
        function waitForSealAndRefresh(attempt = 0) {
          if (!stickySealWidget || sealRefreshRequested) {
            return;
          }

          if (refreshSealWidgets()) {
            return;
          }

          if (attempt >= 20) {
            return;
          }

          window.setTimeout(() => {
            waitForSealAndRefresh(attempt + 1);
          }, 250);
        }

        /**
         * Send the selected selling plan to a Seal widget.
         */
        function changeWidgetSellingPlan(widget, sellingPlanId) {
          if (!widget) {
            return;
          }

          widget.dispatchEvent(
            new CustomEvent(
              'sealsubs:change_selected_selling_plan_id',
              {
                detail: {
                  selling_plan_id: sellingPlanId ?? ''
                }
              }
            )
          );
        }

        /**
         * Synchronise the selected selling plan between every Seal
         * widget for this product.
         */
        function synchroniseSellingPlan(sourceWidget, sellingPlanId) {
          if (sealSelectionIsSynchronising) {
            return;
          }

          sealSelectionIsSynchronising = true;

          const widgets = [
            ...getOriginalSealWidgets(),
            stickySealWidget
          ].filter(Boolean);

          widgets.forEach((widget) => {
            if (widget === sourceWidget) {
              return;
            }

            changeWidgetSellingPlan(widget, sellingPlanId);
          });

          window.setTimeout(() => {
            sealSelectionIsSynchronising = false;
          }, 0);
        }

        /**
         * Read the selling plan selected in the original product form.
         */
        function getOriginalSellingPlanId() {
          const productForm = getOriginalProductForm();

          if (!productForm) {
            return '';
          }

          const sellingPlanInput = productForm.querySelector(
            '[name="selling_plan"]'
          );

          return sellingPlanInput?.value ?? '';
        }

        /**
         * Copy the original form selection into the sticky Seal widget.
         */
        function syncOriginalSellingPlanToStickyWidget() {
          if (!stickySealWidget) {
            return;
          }

          const sellingPlanId = getOriginalSellingPlanId();

          changeWidgetSellingPlan(
            stickySealWidget,
            sellingPlanId
          );
        }

        /**
         * Synchronise the sticky button label and disabled state.
         */
        function syncStickyButton() {
          const originalPrice = originalButton.querySelector(
            '.add-to-cart-text .price'
          );

          const stickyPrice = stickyButton.querySelector(
            '.sticky-add-to-cart__price'
          );

          const originalLabel = originalButton.querySelector(
            '.add-to-cart-text__content'
          );

          const stickyLabel = stickyButton.querySelector(
            '.sticky-add-to-cart__label'
          );

          if (originalPrice && stickyPrice) {
            stickyPrice.innerHTML = originalPrice.outerHTML;
          }

          if (originalLabel && stickyLabel) {
            stickyLabel.textContent =
              originalLabel.textContent
                ?.replace(/\s+/g, ' ')
                ?.trim()
              || '';
          }

          const isDisabled =
            originalButton.disabled
            || originalButton.getAttribute('aria-disabled') === 'true';

          stickyButton.disabled = isDisabled;

          stickyButton.setAttribute(
            'aria-disabled',
            isDisabled ? 'true' : 'false'
          );
        }

        /**
         * Show or hide the complete sticky bar.
         */
        function setStickyVisibility(visible) {
          stickyWrapper.classList.toggle(
            'is-visible',
            visible
          );

          stickyWrapper.setAttribute(
            'aria-hidden',
            visible ? 'false' : 'true'
          );
        }

        /**
         * The sticky button activates the original product button.
         *
         * This allows the theme's original product form to submit the
         * current variant, quantity, selling plan and line-item properties.
         */
        stickyButton.addEventListener('click', () => {
          syncStickyButton();

          if (stickyButton.disabled) {
            return;
          }

          originalButton.click();
        });

        /**
         * Seal fires this event whenever a widget is created.
         */
        document.addEventListener(
          'sealsubs:subscription_widget_created',
          (event) => {
            queueStickySealVisibilityUpdate();

            const createdWidget = event.detail?.element;

            if (
              createdWidget
              && createdWidget !== stickySealWidget
              && belongsToCurrentProduct(createdWidget)
              && stickySealWidget
              && !stickySealWidgetExists()
            ) {
              refreshSealWidgets();
            }

            if (createdWidget === stickySealWidget) {
              syncOriginalSellingPlanToStickyWidget();
            }
          }
        );

        /**
         * Seal fires this event whenever the selected selling plan changes.
         */
        document.addEventListener(
          'sealsubs:selling_plan_changed',
          (event) => {
            const sourceWidget = event.detail?.element;
            const sellingPlanId =
              event.detail?.selling_plan_id ?? '';

            const isRelevantWidget =
              sourceWidget === stickySealWidget
              || getOriginalSealWidgets().includes(sourceWidget);

            if (!isRelevantWidget) {
              return;
            }

            synchroniseSellingPlan(
              sourceWidget,
              sellingPlanId
            );

            syncStickyButton();
          }
        );

        /**
         * Show the sticky bar only after the original add-to-cart
         * button has moved above the viewport.
         */
        const intersectionObserver = new IntersectionObserver(
          ([entry]) => {
            const originalButtonIsAboveViewport = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;

            setStickyVisibility(
              originalButtonIsAboveViewport
            );
          },
          {
            threshold: 0
          }
        );

        intersectionObserver.observe(originalButton);

        /**
         * Watch changes to the original button, such as variant price,
         * availability and button label updates.
         */
        const buttonMutationObserver = new MutationObserver(() => {
          syncStickyButton();
        });

        buttonMutationObserver.observe(originalButton, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true,
          attributeFilter: [
            'disabled',
            'aria-disabled',
            'class'
          ]
        });

        /**
         * Seal loads asynchronously, so watch for its injected DOM.
         */
        const sealMutationObserver = new MutationObserver(() => {
          queueStickySealVisibilityUpdate();
        });

        sealMutationObserver.observe(document.body, {
          childList: true,
          subtree: true
        });

        /**
         * Watch the original product form for selling-plan and
         * subscription-property changes.
         */
        const originalProductForm = getOriginalProductForm();

        if (originalProductForm) {
          originalProductForm.addEventListener(
            'change',
            (event) => {
              const field = event.target;

              if (!(field instanceof HTMLInputElement)
                && !(field instanceof HTMLSelectElement)) {
                return;
              }

              if (
                field.name === 'selling_plan'
                || field.name.startsWith('properties[')
              ) {
                syncStickyButton();
              }
            }
          );
        }

        syncStickyButton();
        updateStickySealVisibility();
        waitForSealAndRefresh();
      }

      initialiseStickyAddToCart();

      document.addEventListener(
        'shopify:section:load',
        initialiseStickyAddToCart
      );
    })();